import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { inject } from 'vue';
import { PRODUCTS } from '@/app/app.constants';
import { installmentSteps, newFlowAnalyticsParams, NewInsuranceSteps } from '@/app/flow';
import { useGoogleAnalytics } from '@/shared/analytics';

export function beforeInstallmentEnter(to: RouteLocationNormalized, __: any, next: NavigationGuardNext) {
  if (to.name !== PRODUCTS.INSTALLMENT) {
    return next();
  }
  const locale = inject('locale');

  return next({
    name: installmentSteps.PAYMENT,
    params: { locale },
    query: {
      ...to.query,
    },
    replace: true,
  } as RouteLocationRaw);
}

export function beforeNewFlowEnter(to: RouteLocationNormalized, __: any, next: NavigationGuardNext) {
  useGoogleAnalytics().setProductParams(newFlowAnalyticsParams);
  if (to.name !== PRODUCTS.CAR_INSURANCE) {
    return next();
  }
  const locale = inject('locale');

  return next({
    name: NewInsuranceSteps.PHONE,
    params: { locale },
    query: {
      ...to.query,
    },
    replace: true,
  } as RouteLocationRaw);
}
